import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import {
  grey2,
  grey5,
  grey9,
  purple1,
  purple2,
} from 'approot/shared/styles/colours.style';
import {
  flexCentreAlignCss,
  flexColumnCss,
} from 'approot/shared/styles/flex.style';
import { spacing12, spacing16 } from 'approot/shared/styles/spacing.style';
import { baseDropItemCss } from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drop.style';

type InteractiveDropItemTargetProps = {
  $isOver?: boolean;
  $canDrop?: boolean;
  $hasDropped?: boolean;
  $isCorrect?: boolean;
  $isResponsive?: boolean;
  $isVisible?: boolean;
  $isOutlined?: boolean;
  $isBackgroundHighlighted?: boolean;
};

export const InteractiveCategoriseDropItemTarget = styled.div<InteractiveDropItemTargetProps>`
  ${flexCentreAlignCss}
  background-color: ${grey2};
  border: 2px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  color: ${grey5};
  flex-wrap: wrap;
  gap: ${rem(spacing16)};
  padding: ${rem(spacing12)};
  position: relative;
  flex-grow: 1;
  min-height: ${rem(200)};

  ${({ $canDrop, $isOver }) =>
    $canDrop &&
    !$isOver &&
    `
    background-color: ${purple1};
    border: 2px dashed ${grey9};
  `}

  ${({ $isOver }) =>
    $isOver &&
    `
    background-color: ${purple2};
    border: 2px dashed ${grey9};
  `}

  ${({ $isOutlined }) =>
    $isOutlined &&
    `
      border: 2px dashed ${grey9};
    `}

  ${({ $isBackgroundHighlighted }) =>
    $isBackgroundHighlighted &&
    `
      background-color: ${purple1};
    `}
`;

export const InteractiveCategoriseDropItemClickable = styled(
  InteractiveCategoriseDropItemTarget
)`
  cursor: pointer;
`;

export const InteractiveDropItem = styled.div`
  ${flexColumnCss}
`;

export const InteractiveDropItemTarget = styled.div<
  InteractiveDropItemTargetProps & {
    $fullWidth?: boolean;
    $fullHeight?: boolean;
  }
>`
  ${flexCentreAlignCss}
  ${baseDropItemCss}

  ${({ $isVisible }) =>
    !$isVisible &&
    `
      background-color: transparent;
      border-color: transparent;
      &:before {
        content: '';
      }
    `}

  width: ${rem(88)};
  height: ${rem(88)};

  ${({ $fullWidth }) =>
    $fullWidth &&
    `
    width: 100%;
  `}

  ${({ $fullHeight }) =>
    $fullHeight &&
    `
    height: 100%;
  `}
`;
